import { Theme } from '@core/utils/css';
import { ConfigProvider, theme } from 'antd';
import React, { memo, PropsWithChildren } from 'react';

export const AntDesignConfig = memo((props: PropsWithChildren<{}>) => {
  const { defaultAlgorithm, darkAlgorithm } = theme;
  return (
    <ConfigProvider
      theme={{
        algorithm: Theme.isDark ? darkAlgorithm : defaultAlgorithm,
        token: {
          colorPrimary: '#556ee6',
        },
        components: {
          Form: {
            margin: 12,
            marginLG: 12,
            verticalLabelPadding: '0 0 0',
          },
          Table: {
            headerBg: Theme.modalBackgroundColor,
            headerSplitColor: Theme.modalBackgroundColor,
            cellPaddingBlock: 12,
          },
          Popover: {
            zIndexPopup: 2000,
          },
          Input: {
            hoverBorderColor: Theme.inputBorderColor,
            activeBorderColor: Theme.inputBorderColor,
            activeShadow: '0 0 0 2px rgba(5, 145, 255, 0.1)',
          },
          Select: {
            colorPrimaryHover: Theme.inputBorderColor,
            colorPrimaryActive: Theme.inputBorderColor,
            colorPrimaryBorderHover: Theme.inputBorderColor,
            colorPrimaryBorder: Theme.inputBorderColor,
            colorPrimaryBg: Theme.inputBorderColor,
            colorPrimary: Theme.inputBorderColor,
          },
          DatePicker: {
            hoverBorderColor: Theme.inputBorderColor,
            activeBorderColor: Theme.inputBorderColor,
            activeShadow: '0 0 0 2px rgba(5, 145, 255, 0.1)',
          },
          Image: {
            zIndexPopupBase: 2000,
            zIndexPopup: 2001,
          },
        },
      }}
    >
      {props.children}
    </ConfigProvider>
  );
});
